var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 2.73438C6.25 2.42357 6.37346 2.1255 6.59323 1.90573C6.813 1.68597 7.11107 1.5625 7.42188 1.5625C7.73268 1.5625 8.03075 1.68597 8.25052 1.90573C8.47028 2.1255 8.59375 2.42357 8.59375 2.73438V4.6875H16.4062V2.73438C16.4062 2.42357 16.5297 2.1255 16.7495 1.90573C16.9693 1.68597 17.2673 1.5625 17.5781 1.5625C17.8889 1.5625 18.187 1.68597 18.4068 1.90573C18.6265 2.1255 18.75 2.42357 18.75 2.73438V4.6875C19.5788 4.6875 20.3737 5.01674 20.9597 5.60279C21.5458 6.18884 21.875 6.9837 21.875 7.8125V18.75C21.875 19.5788 21.5458 20.3737 20.9597 20.9597C20.3737 21.5458 19.5788 21.875 18.75 21.875H6.25C5.4212 21.875 4.62634 21.5458 4.04029 20.9597C3.45424 20.3737 3.125 19.5788 3.125 18.75V7.8125C3.125 6.9837 3.45424 6.18884 4.04029 5.60279C4.62634 5.01674 5.4212 4.6875 6.25 4.6875V2.73438ZM7.03125 9.375C6.61685 9.375 6.21942 9.53962 5.9264 9.83265C5.63337 10.1257 5.46875 10.5231 5.46875 10.9375V17.9688C5.46875 18.3832 5.63337 18.7806 5.9264 19.0736C6.21942 19.3666 6.61685 19.5312 7.03125 19.5312H17.9688C18.3832 19.5312 18.7806 19.3666 19.0736 19.0736C19.3666 18.7806 19.5312 18.3832 19.5312 17.9688V10.9375C19.5312 10.5231 19.3666 10.1257 19.0736 9.83265C18.7806 9.53962 18.3832 9.375 17.9688 9.375H7.03125Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.3d25185cb7a33bfdf61ffefd04d88c98.svg";
export { ForwardRef as ReactComponent };